import {
  Component,
  Input,
  Output,
  EventEmitter,
  ElementRef,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { OpsInputComponent } from '../ops-input/ops-input.component';
import { OpsSettingsAddButtonComponent } from '../ops-settings-add-button/ops-settings-add-button.component';

@Component({
  selector: 'ops-add-additional-media-channel',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    OpsInputComponent,
    OpsSettingsAddButtonComponent,
  ],
  templateUrl: './ops-add-additional-media-channel.component.html',
  styleUrl: './ops-add-additional-media-channel.component.scss',
})
export class OpsAddAdditionalMediaChannelComponent {
  @Input() isPreview?: boolean = false;
  @Output() createdChannel = new EventEmitter<string>();

  channelName?: string = '';

  isEditing?: boolean = false;

  constructor(private elementRef: ElementRef) {}

  setChannelName(value: string) {
    this.channelName = value;
  }

  addSocialMediaChannel() {
    this.isEditing = true;

    setTimeout(() => {
      this.elementRef.nativeElement.getElementsByTagName('input')[0].focus();
    }, 100);
  }

  cancelEdit() {
    this.isEditing = false;
    this.channelName = '';
  }

  saveChanges() {
    if (!this.channelName) {
      return;
    }

    const chName = this.channelName + '';
    this.cancelEdit();

    this.createdChannel.emit(chName);
  }

  onKeyDown(event: KeyboardEvent) {
    // if (event.key === 'Backspace') {
    //   const currentFocusedElement = document.activeElement;
    //   // Get all focusable elements
    //   const focusableElements = Array.from(
    //     document.querySelectorAll(
    //       'a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
    //     )
    //   ).filter(
    //     (el) =>
    //       !el.hasAttribute('disabled') && el.getAttribute('tabindex') !== '-1'
    //   );
    //   // Find the index of the currently focused element in the list of focusable elements
    //   const currentIndex = focusableElements.indexOf(currentFocusedElement);
    //   // Get the previous focusable element, if it exists
    //   const previousElement = focusableElements[currentIndex - 1];
    //   if (previousElement) {
    //     (previousElement as any).focus();
    //   }
    //   return;
    // }
  }
}
